<template>
    <div class="content">
        <template v-if="templateIndex ===1">
            <Banner></Banner>
            <Create></Create>
            <Service></Service>
            <Solution></Solution>
            <Bottom :data="attr" v-if="attr.d_num"></Bottom>
            <Footer></Footer>
        </template>
        <template v-else-if="templateIndex===2">
            <Banner1 />
            <Solution1 />
            <Bottom1 :data="attr" v-if="attr.d_num"/>
            <Create1 />
            <Service1 />
            <Footer1></Footer1>
        </template>
        <template v-else-if="templateIndex === 3">
            <Banner2 />
            <Solution2 />
            <Service2 />
            <Bottom2  :data="attr" v-if="attr.d_num"/>
            <Create2 />
            <Footer2></Footer2>
        </template>
    </div>
</template>
<script>
import { computed, onMounted,reactive,ref, toRefs } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
// 模板一组件
import Banner from '@/components/Banner.vue'
import Create from '@/components/Create.vue'
import Service from '@/components/Service.vue'
import Solution from '@/components/Solution.vue'
import Bottom from '@/components/Bottom.vue'
import Footer from '@/components/Footer.vue'

// 模板二组件
import Banner1 from '@/components1/Banner.vue'
import Create1 from '@/components1/Create.vue'
import Service1 from '@/components1/Service.vue'
import Solution1 from '@/components1/Solution.vue'
import Bottom1 from '@/components1/Bottom.vue'
import Footer1 from '@/components1/Footer.vue'

// 模板三组件
import Banner2 from '@/components2/Banner.vue'
import Create2 from '@/components2/Create.vue'
import Service2 from '@/components2/Service.vue'
import Solution2 from '@/components2/Solution.vue'
import Bottom2 from '@/components2/Bottom.vue'
import Footer2 from '@/components2/Footer.vue'
export default {
    components:{
        Banner,
        Create,
        Service,
        Solution,
        Bottom,
        Footer,

        Solution1,
        Service1,
        Banner1,
        Create1,
        Bottom1,
        Footer1,

        Banner2,
        Create2,
        Service2,
        Solution2,
        Bottom2,
        Footer2
    },
    setup(){
        let host = ref("chenxixx.cn");
        let state = reactive({
            attr:{
                d_num: "1.9W",
                good_num: "574",
                u_num: "1.3W",
            }
        });
        const store = useStore()
        onMounted(()=>{
            if (process.env.NODE_ENV !== "development") {
                host.value = window.location.host.replace("www.", "");
            }
            getData()
        })
        let templateIndex = computed(()=>{
            return store.state.templateIndex;
        })
        const getData = ()=>{
            axios({
                url:`http://ijj-admin.ijianji.cn/api/web/accounts?timestamp=1693218106816&nonce=NLuClgLsBccJlBQ5-ea2_xbJEoKUdfDL&q=${host.value}`,
                method:'get'
            }).then(response=>{
                const res = response.data;
                let data = {
                    companyName:res.data.list[0].title,
                    record_num:res.data.list[0].icp,
                    email: res.data.list[0]['email'],
                    address: res.data.list[0].address,
                    intro: res.data.list[0].intro,
                    title: res.data.list[0].title
                }
                if (res.data.list[0].attr != '') {
                    state.attr = JSON.parse(res.data.list[0].attr)
                }
                document.getElementsByTagName('title')[0].text = res.data.list[0].title;
                store.commit("setCompany", data)
            })
        }
        return{
            templateIndex,
            ...toRefs(state)
        }
    }
}
</script>
<style scoped lang="scss">
    .content{
        width: 100%;
    }
</style>